import adobeIcon from "@/assets/applications/AdobeIcon.svg";
import calendarIcon from "@/assets/applications/CalendarIcon.svg";
import chromeIcon from "@/assets/applications/ChromeIcon.svg";
import excelIcon from "@/assets/applications/ExcelIcon.svg";
import foxitIcon from "@/assets/applications/FoxitIcon.svg";
import kofaxIcon from "@/assets/applications/KofaxIcon.svg";
import outlookIcon from "@/assets/applications/OutlookIcon.svg";
import photosIcon from "@/assets/applications/WindowsPhotos.svg";
import powerpointIcon from "@/assets/applications/PowerpointIcon.svg";
import teamsIcon from "@/assets/applications/TeamsIcon.svg";
import wordIcon from "@/assets/applications/WordIcon.svg";
import zoomIcon from "@/assets/applications/ZoomIcon.svg";

export const APP_ICON_MAP: Record<string, string> = {
	"Microsoft Word": wordIcon,
	"Microsoft Outlook": outlookIcon,
	"Microsoft Outlook Calendar": calendarIcon,
	"Adobe Acrobat": adobeIcon,
	"Microsoft Powerpoint": powerpointIcon,
	"Microsoft Excel": excelIcon,
	"Zoom": zoomIcon,
	"Google Chrome": chromeIcon,
	"Microsoft Teams": teamsIcon,
	"Kofax": kofaxIcon,
	"Foxit": foxitIcon,
	"Photos": photosIcon,
};
